import useErrors from '../../error/useErrors';
import { useErrorStore } from '../../error';
import { serviceErrorSerializer } from './serviceErrors';

/*
 * Wraps the generic useErrors hook to surface connectStore API errors.
 * Listens to the per-action observed tokens bumped by dispatchErrors /
 * errorStore.dispatchError, serialises them to { title, message }, and
 * lets unmapped errors fall through to the generic error dialog.
 */
function useConnectErrors () {
    const store = useErrorStore();

    const {
        errors,
        hasError,
        isGenericError,
    } = useErrors({
        hook: 'useConnectErrors',
        inputValidator: () => ({}),
        serviceErrorSerializer,
        errorObservables: [
            store.observed.errors.connectGetCurrentPlan,
            store.observed.errors.connectGetPlanDetails,
            store.observed.errors.connectCreateSubscription,
            store.observed.errors.connectUpgradeSubscription,
            store.observed.errors.browseConnectIntegrations,
            store.observed.errors.getConnectToken,
            store.observed.errors.connectCancelSubscription,
        ],
    });

    return {
        errors,
        hasError,
        isGenericError,
    };
}

export default useConnectErrors;
